import { useMemo } from 'react'

import { type SortMode } from 'types/ui'
import { type DropdownOption } from 'components/Dropdown/types'

export default function useSortModeOption(
  sortMode: SortMode,
  options: DropdownOption[]
): DropdownOption | undefined {
  return useMemo(
    (): DropdownOption | undefined =>
      options.find(({ value }) => value === sortMode),
    [sortMode, options]
  )
}
